import type { CalendarSurfaceStore } from '../../index';
import { action, mutator } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export type ExpandSource =
    | 'ExpandButton'
    | 'DateRangeChange'
    | 'Initialize'
    | 'scroll'
    | 'click'
    | 'mousedown'
    | 'touchstart'
    | 'focus'
    | 'resize';

/**
 * Called to update whether the all day well is expanded in this surface
 */
export const updateAllDayWellExpanded = action(
    'updateAllDayWellExpanded',
    (store: CalendarSurfaceStore, newValue: boolean, source: ExpandSource) => {
        if (store.isAllDayWellExpanded === newValue) {
            return {
                store,
                newValue,
                source,
            };
        }
        return addDatapointConfig(
            {
                name: 'updateAllDayWellExpanded',
                customData: {
                    expanded: newValue,
                    source: source,
                },
            },
            {
                store,
                newValue,
                source,
            }
        );
    }
);

mutator(updateAllDayWellExpanded, actionMessage => {
    const { store, newValue } = actionMessage;
    if (store.isAllDayWellExpanded != newValue) {
        store.isAllDayWellExpanded = newValue;
    }
});
